const reservedFirstSegments = new Set([
  "admin",
  "api",
  "catalogo-digital-publico",
  "catalogo-pronto-gratis",
  "quiz",
  "como-funciona",
  "courier",
  "g",
  "home",
  "fulfillment",
  "loja",
  "login",
  "privacy-policy",
  "refund-policy",
  "cancellation-policy",
  "reset-password",
  "lojas",
  "lojas",
  "sign-up",
  "sign-up-first-step",
  "sign-up-second-step",
  "solucoes",
  "terms-of-service",
  "tutoriais",
])

export const isStorePublicTrackingPath = (pathname: string) => {
  const segments = pathname.split("/").filter(Boolean)

  if (segments.length === 0) {
    return false
  }

  const [firstSegment] = segments

  return /^[a-z0-9-]+$/.test(firstSegment) && !reservedFirstSegments.has(firstSegment)
}
